<template>
  <div
    class="text-center">
      <img
        :width="width"
        src="@/assets/img/loading-lg.svg"
        alt="Carregando rapá"
      />
  </div>
</template>

<script>
  export default {
    props: {
      size: { type: String, default: 'sm' },
    },

    computed: {
      width () {
        return this.size == 'sm' ? 25 : 80
      }
    }
  }
</script>